interface PauseOverlayProps {
  onResume: () => void;
  onQuit: () => void;
}

export function PauseOverlay({ onResume, onQuit }: PauseOverlayProps) {
  return (
    <dialog open className="pause-overlay" aria-labelledby="pause-title">
      <section className="pause-card">
        <h2 id="pause-title" className="pause-title">
          Paused
        </h2>
        <div className="pause-actions">
          <button type="button" className="title-btn title-btn--primary" onClick={onResume}>
            Resume
          </button>
          <button type="button" className="title-btn title-btn--ghost" onClick={onQuit}>
            Quit to title
          </button>
        </div>
        <p className="pause-hint">
          <kbd className="pause-kbd">Esc</kbd>
          <kbd className="pause-kbd">Space</kbd>
          <kbd className="pause-kbd">P</kbd>
          <span>to resume</span>
        </p>
      </section>
    </dialog>
  );
}
